import { PatchUserDTO, UserDTO } from "@tumtutor/shared/dto";
import { tumtutorApi } from "./tumtutorApi";

const authApi = tumtutorApi.injectEndpoints({
  endpoints: (builder) => ({
    whoami: builder.query<UserDTO, void>({
      query: () => "auth/whoami",
      providesTags: (user) => [{ type: "user", id: user?.id }],
    }),
    privacyConsent: builder.mutation<void, void>({
      query: () => ({
        url: "auth/privacy-consent",
        method: "POST",
      }),
      invalidatesTags: ["user"],
    }),
    getUser: builder.query<UserDTO, string>({
      query: (userId) => `user/${userId}`,
      providesTags: (user) => [{ type: "user", id: user?.id }],
    }),
    updateUser: builder.mutation<
      void,
      { patchUser: PatchUserDTO; userId: string }
    >({
      query: ({ patchUser, userId }) => ({
        url: `user/${userId}`,
        method: "PATCH",
        body: patchUser,
      }),
      invalidatesTags: (_result, _error, args) => [
        { type: "user", id: args.userId },
      ],
    }),
  }),
});

export const {
  useWhoamiQuery,
  usePrivacyConsentMutation,
  useGetUserQuery,
  useUpdateUserMutation,
} = authApi;
